module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjZmZmZmZmIj48cGF0aCBkPSJtMTc2LTEyMC01Ni01NiAzMDEtMzAyLTE4MS00NSAxOTgtMTIzLTE3LTIzNCAxNzkgMTUxIDIxNi04OC04NyAyMTcgMTUxIDE3OC0yMzQtMTYtMTI0IDE5OC00NS0xODEtMzAxIDMwMVptMjQtNTIwLTgwLTgwIDgwLTgwIDgwIDgwLTgwIDgwWm0zNTUgMTk3IDQ4LTc5IDkzIDctNjAtNzEgMzUtODYtODYgMzUtNzEtNTkgNyA5Mi03OSA0OSA5MCAyMiAyMyA5MFptMTY1IDMyMy04MC04MCA4MC04MCA4MCA4MC04MCA4MFpNNTY5LTU3MFoiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/wand-stars.svg
// module id = cKhZ
// module chunks = 1